







































































import Vue from 'vue'
import Component from 'vue-class-component'
import { Watch } from 'vue-property-decorator'
import DataTable from '../components/DataTable.vue'
import { Action, Getter } from 'vuex-class'
import { FetchArticlesPayload, Article, DataTableAction, CrudDialogMode, UpdateArticlePayload, TargetAudience } from '@/utils/types'
import { DataTableHeader } from 'vuetify'
import { translate } from '@/utils/helpers'
import ArticleCrud from '../components/ArticleCrud.vue'

  @Component({
    components: { DataTable, ArticleCrud }
  })
export default class Articles extends Vue {
  @Action fetchArticles!: (
    payload: FetchArticlesPayload
  ) => Promise<void>;

  @Action updateArticle!: (
    payload: UpdateArticlePayload
  ) => Promise<boolean>;

  @Action createArticle!: (
    paylod: Article
  ) => Promise<boolean>

  @Getter articles!: Article[];

    currentTab = 0;
    itemsPerPage = 100;
    isViewingArchive = false;
    isLoading = false;
    targetAudience: TargetAudience | undefined = TargetAudience.EVERYONE;
    isErrorSnackbarVisible = false;
    isArchiveConfiramtionDialogVisible = false
    selectedArticle: Article | null = null;
    currentCrudDialogMode = CrudDialogMode.NONE

    @Watch('currentTab')
    async onCurrentTabChange (tab: number) {
      this.isLoading = true
      this.isViewingArchive = tab === 3
      switch (tab) {
        case 0:
          this.targetAudience = TargetAudience.EVERYONE
          break
        case 1:
          this.targetAudience = TargetAudience.YOUTH
          break
        case 2:
          this.targetAudience = TargetAudience.EMPLOYERS
          break
        default:
          this.targetAudience = undefined
      }
      await this.fetchArticles({ isArchived: this.isViewingArchive, targetAudience: this.targetAudience })
      this.isLoading = false
    }

  articlesHeaders: DataTableHeader[] = [
    { text: 'כותרת', value: 'title' },
    { text: 'תחום', value: 'tags' },
    { text: 'מחבר', value: 'author.email' },
    { text: 'תאריך', value: 'createdAt' }
  ];

  async mounted () {
    await this.fetchArticles({ isArchived: false, targetAudience: TargetAudience.EVERYONE })
  }

  get articlesActions (): DataTableAction<Article>[] {
    return [
      {
        text: this.isViewingArchive ? 'הוצאה מהארכיון' : 'העברה לארכיון',
        icon: 'mdi-archive',
        handler: (article) => this.openCrudDialog(article, CrudDialogMode.DELETE)
      },
      {
        text: 'עריכה',
        icon: 'mdi-pencil',
        handler: (article) => this.openCrudDialog(article, CrudDialogMode.EDIT)
      }
    ]
  }

  get formattedArticles () {
    return this.articles.map((article) => ({
      ...article,
      createdAt: new Date(article.createdAt ?? '').toLocaleDateString('he-IL'),
      tags: article.tags?.map((option) => translate(option))
    }))
  }

  get isDialogOpen () {
    return this.currentCrudDialogMode !== CrudDialogMode.NONE
  }

  get currentDialogTitle () {
    switch (this.currentCrudDialogMode) {
      case CrudDialogMode.CREATE:
        return 'יצירת כתבה חדש'
      case CrudDialogMode.EDIT:
        return 'עריכת כתבה'
    }
  }

  openCrudDialog (article: Article | null = null, mode: CrudDialogMode = CrudDialogMode.CREATE) {
    this.selectedArticle = this.articles.find(a => a.id === article?.id) ?? null
    if (mode === CrudDialogMode.DELETE) {
      this.isArchiveConfiramtionDialogVisible = true
    } else {
      this.currentCrudDialogMode = mode
    }
  }

  closeCrudDialog () {
    this.currentCrudDialogMode = CrudDialogMode.NONE
    this.selectedArticle = null
  }

  async searchArticle (search: string) {
    await this.fetchArticles({
      limit: this.itemsPerPage,
      page: 1,
      targetAudience: this.targetAudience,
      title: search,
      isArchived: this.isViewingArchive
    })
  }

  async handleCrudDialogSubmit (article: Article) {
    switch (this.currentCrudDialogMode) {
      case CrudDialogMode.CREATE:
        this.isErrorSnackbarVisible = !(await this.createArticle(article))
        break
      case CrudDialogMode.EDIT:
        this.isErrorSnackbarVisible = !(await this.updateArticle(article))
        break
    }
    this.closeCrudDialog()
  }

  async changeArticleArchivedState (article: Article | null) {
    if (!article || !article.id) {
      return
    }
    await this.updateArticle({
      id: article.id,
      isArchived: !this.isViewingArchive
    })
    await this.fetchArticles({ isArchived: this.isViewingArchive, targetAudience: this.targetAudience })
    this.isArchiveConfiramtionDialogVisible = false
  }
}

